export function validatePositionBreakPrice(prices) {
  if (prices.length === 0 || !prices)
    return [false, 'No break prices provided.'];
  for (const price of prices) {
    if (isNaN(price) || price <= 0) return [false, 'All prices must be numbers greater than zero.'];
  }
  return [true, ''];
}
